if (!customElements.get('sticky-atc-bar')) {
  customElements.define(
    'sticky-atc-bar',
    class StickyAtcBar extends HTMLElement {
      constructor() {
        super();
        document.body.classList.add('sticky-atc-bar-enabled');

        this.selectors = {
          variantIdSelect: '[name="id"]',
        };
      }

      get quantityInput() {
        return this.querySelector('quantity-input input');
      }
      get quantity() {
        return this.querySelector('quantity-input');
      }
      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
      get productId() {
        return this.getAttribute('data-product-id');
      }
      get select() {
        return this.querySelector('select');
      }
      get productForm() {
        return this.querySelector('form[is="product-form"]');
      }

      connectedCallback() {
        this.productFormActions = document.querySelector(`.main-product-form[data-product-id="${this.productId}"]`);
        this.mainProductInfo = document.querySelector(`product-info[data-product-id="${this.productId}"]`);
        this.container = this.closest('.sticky-atc-bar');
        this.submitButton = this.querySelector('[type="submit"]');
        this.buyNowButton = this.querySelector('[data-sticky-buynow]');
        this.selectedVariantId = this.querySelector(this.selectors.variantIdSelect).value;

        this.variantData = this.getVariantData();

        this.init();
        this.initPills();
        this.select.addEventListener('change', (e) => {
          if (this.isUpdating) return;
          this.isUpdating = true;

          this.updateQuantityInput();
          this.reflectActivePill();

          this.mainVariantSelects = this.mainProductInfo && this.mainProductInfo.querySelector('variant-selects');
          const selectedVariantId = this.querySelector(this.selectors.variantIdSelect).value;
          this.currentVariant = this.variantData.find((variant) => variant.id === Number(selectedVariantId));

          if (this.mainVariantSelects) {
            Array.from(this.mainVariantSelects.querySelectorAll('select, fieldset'), (element, index) => {
              const variantOptionVal = this.currentVariant.options[index];
              switch (element.tagName) {
                case 'SELECT':
                  element.value = variantOptionVal;
                  const options = element.querySelectorAll('option');
                  options.forEach((option) => option.removeAttribute('selected'));

                  element.value = variantOptionVal;
                  const selectedOption = element.querySelector(`option[value="${variantOptionVal}"]`);
                  if (selectedOption) {
                    selectedOption.setAttribute('selected', 'selected');
                  }
                  break;
                case 'FIELDSET':
                  Array.from(element.querySelectorAll('input')).forEach((radio) => {
                    if (radio.value === variantOptionVal) {
                      radio.checked = true;
                    }
                  });
                  break;
              }
            });
            setTimeout(() => {
              this.mainVariantSelects.dispatchEvent(new Event('change', { detail: { formStickty: true } }));
              this.isUpdating = false;
            }, 0);
          } else {
            this.isUpdating = false;
          }

          this.updatePrice();
          this.updateButton(true, '', false);
          if (!this.currentVariant) {
            this.updateButton(true, '', true);
          } else {
            this.updateButton(!this.currentVariant.available, FoxTheme.variantStrings.soldOut);
          }
        });

        // Listen for variant changes to update sticky bar image
        document.addEventListener('variant:change', (e) => {
          if (e.detail && e.detail.variant && e.detail.productId == this.productId) {
            const variant = e.detail.variant;
            if (variant.featured_image) {
              const stickyImg = this.closest('.sticky-atc-bar')?.querySelector('[id^="StickyAtcImage"]');
              if (stickyImg) {
                const newSrc = variant.featured_image.src.replace(/(\.jpg|\.jpeg|\.png|\.webp)/, '_180x$1') || variant.featured_image.src;
                stickyImg.src = newSrc;
              }
            }
          }
        });

        const hasRequiredFields = this.validateMainProductRequiredFields();
        if (hasRequiredFields) {
          this.submitButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.productFormActions.scrollIntoView({ behavior: 'smooth', block: 'center' });
            setTimeout(() => {
              this.productFormActions.requestSubmit();
            }, 300);
          });
        }

        if (this.buyNowButton) {
          this.buyNowButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            // Products with required line-item properties are handled by the main
            // product form (a bare /cart/add.js would skip those properties), so
            // mirror the Add-to-cart delegation instead of buying directly.
            if (hasRequiredFields && this.productFormActions) {
              this.productFormActions.scrollIntoView({ behavior: 'smooth', block: 'center' });
              setTimeout(() => {
                this.productFormActions.requestSubmit();
              }, 300);
              return;
            }
            this.buyNow();
          });
        }
      }

      /**
       * Custom Buy-now: add the currently selected variant (the native
       * <select name="id"> is the single source of truth) to the cart, then
       * redirect to checkout. Self-contained analogue of the pack builder's
       * express add-then-checkout flow. Disabled while in flight and re-enabled
       * on error; a sold-out / unavailable variant leaves the button disabled
       * via updateButton().
       */
      buyNow() {
        if (this.buyNowLoading || !this.buyNowButton) return;
        if (this.buyNowButton.hasAttribute('disabled')) return;

        const select = this.querySelector(this.selectors.variantIdSelect);
        const variantId = select && select.value;
        if (!variantId) return;

        this.buyNowLoading = true;
        this.buyNowButton.setAttribute('disabled', 'disabled');

        fetch(this.cartAddUrl(), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
        })
          .then((response) => response.json())
          .then((data) => {
            // A cart/add error response carries a `status` field (e.g. sold out).
            if (data && data.status) {
              this.buyNowLoading = false;
              this.buyNowButton.removeAttribute('disabled');
              return;
            }
            window.location.href = this.checkoutUrl();
          })
          .catch(() => {
            this.buyNowLoading = false;
            this.buyNowButton.removeAttribute('disabled');
          });
      }

      /**
       * Shop root that respects the storefront locale subpath. Prefers the value
       * passed in from Liquid (routes.root_url via data-checkout-url), then the
       * global Shopify routes, then '/'. Always returns a trailing slash.
       */
      shopRoot() {
        let root =
          this.dataset.checkoutUrl ||
          (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
          '/';
        if (root.charAt(root.length - 1) !== '/') root += '/';
        return root;
      }

      cartAddUrl() {
        return this.shopRoot() + 'cart/add.js';
      }

      checkoutUrl() {
        return this.shopRoot() + 'checkout';
      }

      validateMainProductRequiredFields() {
        const mainForm = this.mainProductInfo;
        if (!mainForm) return true;
        const requiredFields = mainForm.querySelectorAll('[data-custom-property]');
        return requiredFields.length > 0;
      }

      /**
       * Desktop size pills drive the native <select> (the single source of
       * truth the form submits). On click we set select.value + dispatch a
       * change so the existing variant/price sync runs unchanged; then we
       * reflect the select's current value back onto the active pill. The
       * `pills-ready` class is what flips the CSS from "select visible" to
       * "pills visible" on desktop, so with JS off the select stays usable.
       */
      initPills() {
        this.sizeWrap = this.querySelector('.sticky-atc-bar__size');
        this.pills = Array.from(this.querySelectorAll('.sticky-atc-bar__pill'));
        if (!this.pills.length || !this.sizeWrap) return;

        this.sizeWrap.classList.add('pills-ready');
        this.pills.forEach((pill) => {
          pill.addEventListener('click', (event) => {
            event.preventDefault();
            const id = pill.getAttribute('data-variant-id');
            if (id && this.select.value !== id) {
              this.select.value = id;
              this.select.dispatchEvent(new Event('change', { bubbles: true }));
            }
            this.reflectActivePill();
          });
        });
        this.reflectActivePill();
      }

      reflectActivePill() {
        if (!this.pills || !this.pills.length) return;
        const current = this.select.value;
        this.pills.forEach((pill) => {
          pill.classList.toggle('is-active', pill.getAttribute('data-variant-id') === current);
        });
      }

      updateQuantityInput() {
        const quantity = document.querySelector(`#QuantitySticky-${this.sectionId}`);
        if (!quantity) return;
        this.currentVariant = this.variantData.find((variant) => variant.id === Number(this.selectedVariantId));
        fetch(`${this.getAttribute('data-url')}?variant=${this.currentVariant.id}&section_id=${this.sectionId}`)
          .then((response) => response.text())
          .then((responseText) => {
            const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const quantity = document.querySelector(`#QuantitySticky-${this.sectionId}`);
            const newQuantity = parsedHTML.querySelector(`#QuantitySticky-${this.sectionId}`);
            if (newQuantity) {
              quantity.innerHTML = newQuantity.innerHTML;
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {});
      }

      getVariantData() {
        this.variantData =
          this.variantData || JSON.parse(this.container.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }

      init() {
        if (!this.productFormActions) {
          this.container.classList.add('sticky-atc-bar--show');
          return;
        }

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.checkDevice.bind(this);
        this.checkDevice();

        const rootMargin = `-80px 0px 0px 0px`;
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const method = entry.intersectionRatio !== 1 ? 'add' : 'remove';
              this.container.classList[method]('sticky-atc-bar--show');
            });
          },
          { threshold: 1, rootMargin }
        );
        this.setObserveTarget();
        this.syncWithMainProductForm();
      }

      setObserveTarget() {
        this.observer.observe(this.productFormActions);
        this.observeTarget = this.productFormActions;
        this.setupInlineAtcClearance();
      }

      setupInlineAtcClearance() {
        const target = this.productFormActions;
        if (!target || typeof IntersectionObserver === 'undefined') return;

        let inViewport = false;
        let rafId = null;

        const updateClearance = () => {
          rafId = null;
          if (!inViewport) return;
          const rect = target.getBoundingClientRect();
          // Distance from viewport bottom to top of the inline buy-buttons
          // row. Add 20px buffer so the chat widget sits clear of the button.
          const clearance = Math.max(0, window.innerHeight - rect.top + 20);
          document.documentElement.style.setProperty('--inline-atc-clearance', clearance + 'px');
        };

        const onScroll = () => {
          if (rafId === null) rafId = requestAnimationFrame(updateClearance);
        };

        const visObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              inViewport = entry.isIntersecting;
              if (inViewport) {
                document.body.classList.add('inline-atc-visible');
                updateClearance();
                window.addEventListener('scroll', onScroll, { passive: true });
                window.addEventListener('resize', onScroll);
              } else {
                document.body.classList.remove('inline-atc-visible');
                window.removeEventListener('scroll', onScroll);
                window.removeEventListener('resize', onScroll);
              }
            });
          },
          { threshold: 0 }
        );
        visObserver.observe(target);
      }

      checkDevice(e) {
        document.documentElement.style.setProperty('--sticky-atc-bar-height', this.clientHeight + 'px');
      }

      updateButton(disable = true, text, modifyClass = true) {
        // Keep the custom Buy-now in lockstep with the Add-to-cart availability
        // (sold out / unavailable => disabled). Never fight an in-flight buy-now.
        if (this.buyNowButton && !this.buyNowLoading) {
          this.buyNowButton.toggleAttribute('disabled', !!disable);
        }

        const productForm = this.querySelector('#product-form-sticky-atc-bar');
        if (!productForm) return;

        const addButton = productForm.querySelector('[name="add"]');
        if (!addButton) return;

        const addButtonText = addButton.querySelector('span');
        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          addButtonText.textContent = FoxTheme.variantStrings.addToCart;
        }
      }

      updatePrice() {
        const classes = {
          onSale: 'f-price--on-sale',
          soldOut: 'f-price--sold-out',
        };
        const selectors = {
          priceWrapper: '.f-price',
          salePrice: '.f-price-item--sale',
          compareAtPrice: ['.f-price-item--regular'],
          unitPriceWrapper: '.f-price__unit-wrapper',
        };
        const moneyFormat = FoxTheme.settings.moneyFormat;
        const { priceWrapper, salePrice, unitPriceWrapper, compareAtPrice } = FoxTheme.utils.queryDomNodes(
          selectors,
          this
        );
        const unitPrice = unitPriceWrapper.querySelector('.f-price__unit');

        const { compare_at_price, price, unit_price_measurement } = this.currentVariant;

        // On sale.
        if (compare_at_price && compare_at_price > price) {
          priceWrapper.classList.add(classes.onSale);
        } else {
          priceWrapper.classList.remove(classes.onSale);
        }

        // Sold out.
        if (!this.currentVariant.available) {
          priceWrapper.classList.add(classes.soldOut);
        } else {
          priceWrapper.classList.remove(classes.soldOut);
        }

        if (salePrice) salePrice.innerHTML = FoxTheme.Currency.formatMoney(price, moneyFormat);

        if (compareAtPrice && compareAtPrice.length && compare_at_price > price) {
          compareAtPrice.forEach(
            (item) => (item.innerHTML = FoxTheme.Currency.formatMoney(compare_at_price, moneyFormat))
          );
        } else {
          compareAtPrice.forEach((item) => (item.innerHTML = FoxTheme.Currency.formatMoney(price, moneyFormat)));
        }

        if (unit_price_measurement && unitPrice) {
          unitPriceWrapper.classList.remove('hidden');
          const unitPriceContent = `<span>${FoxTheme.Currency.formatMoney(
            this.currentVariant.unit_price,
            moneyFormat
          )}</span>/<span data-unit-price-base-unit>${FoxTheme.Currency.getBaseUnit(this.currentVariant)}</span>`;
          unitPrice.innerHTML = unitPriceContent;
        } else {
          unitPriceWrapper.classList.add('hidden');
        }
      }

      syncWithMainProductForm() {
        FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
          const isMainProduct = event.data.sectionId === this.mainProductInfo.dataset.section;
          if (!isMainProduct) return;
          const variant = event.data.variant;
          const variantInput = this.querySelector('[name="id"]');

          this.currentVariant = variant;
          variantInput.value = variant.id;
          this.reflectActivePill();
          this.updatePrice();
          this.updateButton(true, '', false);
          if (!variant) {
            this.updateButton(true, '', true);
          } else {
            this.updateButton(!variant.available, FoxTheme.variantStrings.soldOut);
          }

          this.updateQuantityInput();
        });
      }
    }
  );
}
